module.exports = __webpack_public_path__ + "fonts/Roboto-Regular5136cbe62a63604402f2fedb97f246f8.woff2]";